export const TWITTER_URL = "https://twitter.com/DAS_UNIVERSE";
export const YOUTUBE_URL = "https://www.youtube.com/@dasverse2022";
export const INSTAGRAM_URL = "https://www.instagram.com/dasverse_official/";

// export const JOIN_URL = "https://lgtv.dailyartstory.com/login?event=ces&lang=";
export const JOIN_URL = "https://lgtv.dailyartstory.com/login?event=normal&login_path=web&lang=";
